import React from "react"
export function TickOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm3.165 4.107l.979 1.136-5.367 4.626a.75.75 0 01-.983-.003l-.072-.072-2.42-2.776 1.131-.986 1.93 2.214 4.802-4.14z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__tick---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
